(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { gql as k, useQuery as ce, useLazyQuery as ke, useMutation as B, isApolloError as We } from "@apollo/client";
import { getOperationName as q } from "@apollo/client/utilities";
import { jsx as r, jsxs as h, Fragment as _ } from "react/jsx-runtime";
import { FormField as $, FieldWrapper as v, Badge as Y, Icon as Z, FlexBox as M, Text as D, List as re, Banner as le, Button as P, Modal as _e, ModalHead as Re, ModalBody as Le, ModalFoot as Be, Spinner as j, Tag as $e, Tooltip as de, FieldSwitch as Fe, InputSelectionList as Ue, SelectionList as Ge, FieldText as ie } from "@dixa/lib-shared-habla";
import { Link as He } from "react-router-dom";
import { colors as x } from "@dixa/lib-shared-tokens";
import { useState as m, useEffect as T, createContext as ue, useContext as ge, createElement as H, useCallback as K } from "react";
import { FormProvider as Ke, useController as qe } from "react-hook-form";
import me from "moment";
import { useInterval as Ve } from "react-use";
import ze from "lodash/lowerCase";
import Qe from "lodash/upperFirst";
import { HookFormText as Je } from "lib-shared-hook-form";
import Ye from "classnames";
import { MockedProvider as Ze } from "@apollo/client/testing";
import { render as je } from "@testing-library/react";
const pe = k`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, he = k`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
    $renderConditions: [Management_JSONObject!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, fe = k`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
    $renderConditions: [Management_JSONObject!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, Ce = k`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, en = (e, t) => function(n, o) {
  return ce(n, {
    ...o,
    context: {
      operationName: q(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, tn = (e, t) => function(n, o) {
  return ke(n, {
    ...o,
    context: {
      operationName: q(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, nn = (e, t, n) => function(o, i) {
  return n.query({
    query: o,
    variables: i,
    context: {
      operationName: q(o),
      widgetId: e,
      widgetType: t
    }
  });
}, on = (e, t) => function(n, o) {
  return B(n, {
    ...o,
    context: {
      operationName: q(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, rn = ({
  getValueByKey: e
}) => {
  const t = e("dixaApiTokenId")?.value, n = e("dixaApiTokenName")?.value;
  return /* @__PURE__ */ r($, { children: /* @__PURE__ */ r(v, { label: "Dixa API-Token", children: !n || !t ? /* @__PURE__ */ r(_, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ h(_, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ r(Y, { variant: "secondary", size: "small", children: n }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ r(He, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, Xe = ({
  error: e
}) => e.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", sn = ({
  errors: e
}) => e.some((t) => Xe({ error: t })), et = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", an = ({
  errors: e
}) => e.some((t) => et({ error: t })), tt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", cn = ({
  errors: e
}) => e.some((t) => tt({ error: t })), nt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", ln = ({
  errors: e
}) => e.some((t) => nt({ error: t })), ot = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", dn = ({
  errors: e
}) => e.some((t) => ot({ error: t })), rt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", un = ({
  errors: e
}) => e.some((t) => rt({ error: t })), it = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", gn = ({
  errors: e
}) => e.some((t) => it({ error: t })), st = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", mn = ({
  errors: e
}) => e.some((t) => st({ error: t })), at = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", pn = ({
  errors: e
}) => e.some((t) => at({ error: t })), ct = ({
  error: e
}) => e.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", lt = ({
  errors: e
}) => e.some((t) => ct({ error: t })), dt = (e) => {
  const { delay: t = 2e3 } = e || {}, [n, o] = m(!1);
  return T(() => {
    const s = n ? window.setTimeout(() => o(!1), t) : void 0;
    return () => window.clearTimeout(s);
  }, [t, n]), { isCopied: n, copy: (s) => {
    navigator.clipboard.writeText(s), o(!0);
  } };
}, ut = "_errorWrapper_171rr_1", gt = "_copyIcon_171rr_5", Q = {
  errorWrapper: ut,
  copyIcon: gt
}, ye = ({
  error: e,
  retry: t,
  isMisconfigured: n = !1,
  hideCopyButton: o = !1
}) => {
  const s = e && We(e) && e?.graphQLErrors?.length > 0, { isCopied: a, copy: u } = dt(), g = /* @__PURE__ */ r(
    Z,
    {
      color: x.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (n || s && lt({
    errors: e.graphQLErrors
  }))
    return /* @__PURE__ */ h(M, { margin: "0 0 100", padding: "200", className: Q.errorWrapper, children: [
      /* @__PURE__ */ r(M, { margin: "0 300 0 0", alignItems: "center", children: g }),
      /* @__PURE__ */ r(D.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!s)
    return /* @__PURE__ */ r(M, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ r(
      re.Item,
      {
        contentLeft: g,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const f = e?.graphQLErrors || [];
  return /* @__PURE__ */ h(
    M,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: Q.errorWrapper,
      children: [
        f.map((l, p) => {
          const d = l?.extensions?.integration, C = d?.message || e?.message || "No error message available", y = d?.responseBody && JSON.parse(d?.responseBody), w = y?.errorMessages || [], b = y?.warningMessages || [], c = [...w, ...b].join(" ");
          return /* @__PURE__ */ r(
            re.Item,
            {
              title: C,
              titleSecondary: c,
              contentLeft: g
            },
            p
          );
        }),
        !o && /* @__PURE__ */ h(M, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ r(
            le,
            {
              variant: "info",
              description: /* @__PURE__ */ r(D.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ h(M, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ r(P, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ r(
              P,
              {
                variant: "secondary",
                icon: a ? "done" : "copy",
                onClick: () => u(JSON.stringify(f, null, 2)),
                className: Q.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, mt = ({
  headline: e,
  text: t,
  children: n,
  onConfirm: o,
  onCancel: i,
  confirmLabel: s,
  cancelLabel: a = "Cancel",
  confirmVariant: u = "primary",
  cancelVariant: g = "secondary",
  isOpen: f,
  setIsOpen: l,
  showOnClose: p = !1
}) => /* @__PURE__ */ h(
  _e,
  {
    isOpen: f,
    onClose: () => {
      i && i(), l(!1);
    },
    children: [
      /* @__PURE__ */ r(
        Re,
        {
          title: e,
          onClose: p ? i : void 0
        }
      ),
      /* @__PURE__ */ h(Le, { children: [
        t && /* @__PURE__ */ r("div", { style: { width: "600px" }, children: t }),
        n
      ] }),
      /* @__PURE__ */ r(
        Be,
        {
          confirmOnClick: o ? () => {
            o(), l(!1);
          } : void 0,
          cancelOnClick: () => {
            i && i(), l(!1);
          },
          confirmName: s,
          cancelName: a,
          confirmProps: { variant: u },
          cancelProps: { variant: g }
        }
      )
    ]
  }
), X = "The configuration of the integration is not correct. Please check the settings.", hn = ({
  cause: e
}) => /* @__PURE__ */ r(M, { margin: "0 0 400", children: /* @__PURE__ */ r(
  le,
  {
    variant: "fail",
    headline: "This integration is misconfigured",
    description: /* @__PURE__ */ h(M, { gap: "300", flexDirection: "column", children: [
      /* @__PURE__ */ r(D.Paragraph, { children: e || X }),
      /* @__PURE__ */ h(M, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ r(D.Heading, { variant: "heading-3", children: "Additional information" }),
        /* @__PURE__ */ r(D.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
      ] })
    ] })
  }
) }), fn = ({
  form: e,
  integrationId: t,
  onValidSubmit: n,
  error: o,
  onRetry: i,
  isLoading: s,
  isWidgetUnknown: a,
  children: u
}) => o ? /* @__PURE__ */ r(ye, { error: o, retry: i }) : s ? /* @__PURE__ */ r(j, { "data-testid": "widget-settings-loading" }) : a ? /* @__PURE__ */ h(D.Paragraph, { children: [
  "A widget with the id ",
  /* @__PURE__ */ r($e, { children: t }),
  " does not exist."
] }) : /* @__PURE__ */ r(Ke, { ...e, children: /* @__PURE__ */ r(
  "form",
  {
    noValidate: !0,
    tabIndex: -1,
    "data-testid": `widget-settings-form-${t ?? "create-new"}`,
    onSubmit: e.handleSubmit(n),
    children: u
  }
) });
function Cn(e, t = !0) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const yn = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, wn = (e) => {
  const t = ze(e);
  return t.length === 0 ? e : Qe(t);
}, we = "DD MMM YYYY @ HH:mm";
function pt(e, t) {
  return e == null ? t : typeof e == "boolean" ? e : e === "true";
}
function ht(e, t) {
  return e == null ? t : String(e);
}
function bn(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const En = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], An = (e) => {
  if (!e?.trim())
    return "Please add a valid subdomain";
  const n = ["https://", "http://"].find(
    (s) => e.startsWith(s)
  ), o = n ? `Please remove the protocol \`${n}\` from the hostname` : "", i = e.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (o && i)
    return `Please remove the protocol \`${n}\` and the trailing \`/\` from the hostname`;
  if (o)
    return o;
  if (i)
    return i;
};
function ft(e) {
  const t = e.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const n = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(n).toString());
  } catch (o) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${o}`
    );
  }
}
const be = ue(null);
function Ct() {
  const e = ge(be);
  if (e === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return e;
}
function yt() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
const Ee = ue(null), wt = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Ee.Provider
);
function Ae() {
  const e = ge(Ee);
  if (e === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return e;
}
function Nn() {
  window._partner = {
    events: { emit: () => {
    } }
  };
}
const bt = {
  useMutation: B,
  useQuery: () => {
  },
  useLazyQuery: () => {
  },
  executeQuery: () => {
  },
  showNotification: () => {
  },
  showModal: () => {
  }
}, Et = {
  baseUrl: "http://localhost/graphql"
};
function Sn(e, { mocks: t = [], overrides: n = {} } = {}) {
  const o = vi.fn(), i = vi.fn(), a = { ...{
    configuration: Et,
    handleRedirect: o,
    showNotification: i
  }, ...n };
  return { ...je(
    H(
      Ze,
      { mocks: t },
      H(
        be.Provider,
        { value: yt() },
        H(
          wt,
          { value: bt },
          H(e, a)
        )
      )
    )
  ), handleRedirect: o, showNotification: i };
}
function Mn({
  id: e,
  configuration: t
}) {
  const n = t?.settings ?? [];
  return {
    request: {
      query: pe,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          widgetConfigurations: [
            {
              id: e,
              type: t?.type ?? "UNKNOWN",
              name: t?.name ?? "Test widget",
              enabled: t?.enabled ?? !0,
              misconfigured: t?.misconfigured ?? !1,
              misconfigurationCause: t?.misconfigurationCause ?? null,
              additionalProperties: t?.additionalProperties ?? null,
              renderConditions: t?.renderConditions ?? [],
              settings: n
            }
          ]
        }
      }
    }
  };
}
function Tn({
  variables: e,
  result: t
}) {
  const n = {
    ...e,
    renderConditions: e.renderConditions ?? []
  };
  return {
    request: {
      query: fe,
      variables: n
    },
    result: {
      data: {
        Management: {
          createWidgetConfiguration: {
            id: t?.id ?? "new-id",
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            renderConditions: t?.renderConditions ?? n.renderConditions,
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function Dn({
  variables: e,
  result: t
}) {
  return {
    request: {
      query: he,
      variables: e
    },
    result: {
      data: {
        Management: {
          updateWidgetConfiguration: {
            id: e.id,
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled ?? !0,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            renderConditions: t?.renderConditions ?? e.renderConditions ?? [],
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function vn({
  id: e
}) {
  return {
    request: {
      query: Ce,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          deleteWidgetConfiguration: { id: e }
        }
      }
    }
  };
}
function At(e, t) {
  const n = {};
  for (const o of t) {
    const s = e.find((a) => a.key === o.key)?.value;
    o.secret && s === void 0 || (o.type === "boolean" ? n[o.key] = pt(s, o.defaultValue) : n[o.key] = ht(s, o.defaultValue));
  }
  return n;
}
function Nt(e, t) {
  return t.filter((n) => e[n.key] !== void 0).map((n) => ({
    key: n.key,
    value: String(e[n.key]),
    secret: n.secret
  }));
}
async function On(e, {
  fieldDefinitions: t,
  isCreationMode: n,
  create: o,
  update: i,
  renderConditions: s
}) {
  const a = Nt(e, t), u = {
    name: e.name,
    enabled: e.enabled,
    settings: a,
    ...s !== void 0 && { renderConditions: s }
  };
  n ? await o(u) : await i(u);
}
function St(e) {
  const { user_id: t, iss: n } = ft(e);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": n
  };
}
function Mt(e) {
  return e.startsWith("http://localhost");
}
function ee() {
  return { track: (t, n) => window._partner.events.emit(t, n) };
}
const Tt = (e) => {
  switch (e) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: x.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: x.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: x.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: x.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: x.neutral[500],
        tooltip: "Not connected"
      };
  }
}, In = ({
  configuration: e,
  integrationId: t,
  integrationType: n,
  label: o
}) => {
  const [i, s] = m("CONNECTING"), [a, u] = m(""), [g, f] = m(null), { track: l } = ee(), { icon: p, color: d, tooltip: C } = Tt(i), y = 3, w = 15, b = 2e3, [c, A] = m({}), [E, N] = m(0), [W, F] = m(b), [O, V] = m(!1), [Ne, Se] = m(y), {
    isInboundOAuth: Me,
    setIsInboundOAuth: Te,
    hasTriggeredAuthorization: De,
    setHasTriggeredAuthorization: ve
  } = Ct(), { baseUrl: U } = e, Oe = `${U}/auth/connect/${n.toLowerCase()}/${t}`, Ie = `${U}/auth/status/${n.toLowerCase()}/${t}`, te = i === "CONNECTING", ne = (S) => Object.keys(S).length === 0, z = () => {
    V(!1), N(0);
  };
  T(() => {
    const S = localStorage.getItem("authData");
    if (S) {
      const I = JSON.parse(S ?? "{}").access_token;
      A({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${I}`,
          ...Mt(U) && St(I)
        }
      });
    }
  }, [U]), T(() => {
    ne(c) || V(!0);
  }, [c]);
  const xe = () => {
    Se(w), fetch(Ie, { ...c }).then((S) => S.json()).then(({ data: S }) => {
      const { status: R, createdAt: I, createdByName: L } = S;
      switch (R) {
        case "CONNECTING":
          s("CONNECTING");
          break;
        case "CONNECTED": {
          if (l("settings:view:oauth:succeeded", {
            widgetId: t,
            widgetType: n
          }), s("CONNECTED"), I && L) {
            const G = new Date(I);
            isNaN(G.getTime()) || f(G), u(L);
          }
          z();
          break;
        }
        case "NOT_CONNECTED":
        case "CONNECTION_FAILED":
          s(R), z();
      }
    }).catch((S) => {
      console.warn(
        `Fetching OAuth status failed for ${n} ${t}`,
        S
      ), s("CONNECTION_FAILED");
    });
  };
  Ve(
    () => {
      E >= Ne ? (s("CONNECTION_TIMEOUT"), z()) : (xe(), N(E + 1));
    },
    O ? W : null
  );
  const oe = () => {
    l("settings:view:oauth:started", {
      widgetId: t,
      widgetType: n
    }), fetch(Oe, { ...c }).then((S) => S.json()).then(({ data: S }) => {
      const { url: R } = S, I = 620, L = 800, G = window.innerWidth / 2 - I / 2, Pe = window.innerHeight / 2 - L / 2;
      s("CONNECTING"), V(!0), window.open(
        R,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${I},
						height=${L},
						left=${G},
						top=${Pe}`
      );
    }).catch((S) => {
      console.warn(
        `Fetching OAuth connection failed for ${n} ${t}`,
        S
      ), s("CONNECTION_FAILED");
    });
  };
  return T(() => {
    Me && !De && !ne(c) && (ve(!0), Te(!1), oe());
  }, [c]), /* @__PURE__ */ h(_, { children: [
    /* @__PURE__ */ r($, { span: 3, children: /* @__PURE__ */ r(
      v,
      {
        label: o,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ h(M, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ r(
            P,
            {
              icon: "key",
              variant: "secondary",
              onClick: oe,
              disabled: te,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ r(de, { content: C, children: te ? /* @__PURE__ */ r(j, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ h(M, { alignItems: "center", gap: "200", children: [
            /* @__PURE__ */ r(
              Z,
              {
                "data-testid": "oauth-button-status-icon",
                name: p,
                color: d
              }
            ),
            i === "CONNECTED" && a && g && /* @__PURE__ */ h(D.Paragraph, { variant: "4", subdued: !0, children: [
              "Authorized by ",
              a,
              " at",
              " ",
              me(g).format(we)
            ] })
          ] }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ r($, { span: 3 })
  ] });
}, Dt = "_settingsWrapper_eleyu_1", vt = {
  settingsWrapper: Dt
}, Ot = k`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, se = [], xn = ({
  settings: e,
  getValueByKey: t,
  handleChangeSelect: n
}) => {
  const o = "subscriptionListId", s = e?.find(
    (c) => c.key === o
  )?.label ?? "Activate re-/subscription list selection", a = t(o)?.value, { useQuery: u } = Ae(), [g, f] = m(se), [l, p] = m(!!a), [d, C] = m(a), {
    data: y,
    error: w,
    loading: b
  } = u(Ot, {
    skip: !l,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return T(() => {
    a && (C(a), p(!0));
  }, [a]), T(() => {
    const c = y?.Klaviyo?.get_lists;
    if (l && c && !b && !w) {
      const A = c?.data?.map(
        (E) => ({
          value: E?.id,
          label: E?.attributes?.name
        })
      ) || se;
      f(A);
    }
  }, [l, y, b, w]), /* @__PURE__ */ h(_, { children: [
    /* @__PURE__ */ r($, { span: 3, children: /* @__PURE__ */ h(
      M,
      {
        gap: "300",
        flexDirection: "column",
        className: vt.settingsWrapper,
        children: [
          /* @__PURE__ */ r(v, { label: s, children: /* @__PURE__ */ r(
            Fe,
            {
              input: {
                name: `${o}-switch`,
                value: "switchValueFromComponent",
                checked: l,
                onChange: () => {
                  const c = !l;
                  c || n(o, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), p(c);
                }
              }
            }
          ) }),
          l && w && !b && /* @__PURE__ */ r(v, { children: /* @__PURE__ */ r(ye, { error: w }) }),
          l && !w && b && /* @__PURE__ */ r(v, { children: /* @__PURE__ */ r(M, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ r(j, {}) }) }),
          l && !w && !b && g && /* @__PURE__ */ r(v, { label: "Available lists to subscribe to", children: /* @__PURE__ */ r(
            Ue,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (c) => {
                n(o, c), C(c?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (c) => c ? /* @__PURE__ */ r(D.Paragraph, { children: c.label }) : null,
              value: d ? [
                {
                  label: (g || []).find(
                    (c) => c.value === d
                  )?.label,
                  value: d
                }
              ] : [],
              equalityFn: (c, A) => c.value === A.value,
              children: g.map((c) => /* @__PURE__ */ r(Ge.Item, { value: c, children: c.label }, c.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ r($, { span: 3 })
  ] });
}, Pn = (e) => {
  if (e == null)
    return null;
  if (Array.isArray(e))
    return /* @__PURE__ */ r(D.Paragraph, { variant: "5", color: "secondary", align: "right", children: e.join(", ") });
  if (typeof e == "boolean" || e === "true" || e === "false") {
    const o = e === "true" || e === !0;
    return /* @__PURE__ */ r(
      Z,
      {
        name: o ? "check-circle-filled" : "close-circle-filled",
        color: o ? x.green[500] : x.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${o ? "true" : "false"}`
      }
    );
  }
  if (typeof e == "number" || /^\d*\.?\d+$/.test(e))
    return /* @__PURE__ */ r(Y, { variant: "success", size: "small", children: e });
  if (e.startsWith("days_ago: ")) {
    const o = e.replace("days_ago: ", ""), i = o.startsWith("-"), s = o === "0", a = i ? `${o.replace("-", "")} days ago` : `in ${o} days`;
    return /* @__PURE__ */ r(D.Paragraph, { variant: "5", color: "secondary", children: s ? "today" : a });
  }
  const n = me(e);
  return n.isValid() ? /* @__PURE__ */ r(D.Paragraph, { variant: "5", color: "secondary", children: n.format(we) }) : /* @__PURE__ */ r(Y, { variant: "info", size: "small", children: e });
}, kn = (e) => {
  const { isCreationMode: t = !1, label: n, helpIcon: o, name: i } = e, [s, a] = m(t);
  if (!s) {
    const u = typeof n == "string" ? n : "";
    return /* @__PURE__ */ r(v, { label: n, helpIcon: o, children: /* @__PURE__ */ h(
      P,
      {
        "data-testid": `secret-field-button-${i}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => a(!0),
        children: [
          "Update ",
          u
        ]
      }
    ) });
  }
  return /* @__PURE__ */ r(
    It,
    {
      ...e,
      isCreationMode: t,
      onClose: () => a(!1)
    }
  );
}, It = (e) => {
  const { isCreationMode: t, componentProps: n, onClose: o } = e, i = {
    ...n,
    prefix: t ? n?.prefix : {
      type: "button",
      button: { icon: "close", onClick: o }
    }
  };
  return /* @__PURE__ */ r(
    Je,
    {
      ...e,
      componentProps: i,
      shouldUnregister: !0
    }
  );
}, xt = "_wrapper_1lmim_1", Pt = "_wrapperBox_1lmim_4", kt = "_wrapperBoxErrorBorder_1lmim_9", J = {
  wrapper: xt,
  wrapperBox: Pt,
  wrapperBoxErrorBorder: kt
}, ae = (e, t) => e !== "" && t !== "" ? window.btoa(`${e}:${t}`) : "", Wn = (e) => {
  const { isCreationMode: t = !1, label: n, name: o } = e, [i, s] = m(t);
  if (!i) {
    const a = typeof n == "string" ? n : "";
    return /* @__PURE__ */ r(v, { label: n, children: /* @__PURE__ */ h(
      P,
      {
        "data-testid": `secret-field-button-${o}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => s(!0),
        children: [
          "Update ",
          a
        ]
      }
    ) });
  }
  return /* @__PURE__ */ r(
    Wt,
    {
      ...e,
      isCreationMode: t,
      onClose: () => s(!1)
    }
  );
}, Wt = (e) => {
  const {
    name: t,
    control: n,
    label: o,
    rules: i,
    isCreationMode: s,
    usernameLabel: a,
    passwordLabel: u,
    usernamePlaceholder: g,
    passwordPlaceholder: f,
    onClose: l
  } = e, { field: p, fieldState: d } = qe({
    name: t,
    control: n,
    rules: i,
    shouldUnregister: !0
  }), [C, y] = m(""), [w, b] = m(""), c = (N) => {
    y(N), p.onChange(ae(N, w));
  }, A = (N) => {
    b(N), p.onChange(ae(C, N));
  }, E = !!i?.required;
  return /* @__PURE__ */ r(
    v,
    {
      label: o,
      required: E,
      meta: {
        touched: d.isTouched,
        error: d.error?.message
      },
      className: J.wrapper,
      children: /* @__PURE__ */ h(
        M,
        {
          gap: "300",
          flexDirection: "column",
          className: Ye(J.wrapperBox, {
            [J.wrapperBoxErrorBorder]: !!d.error
          }),
          children: [
            /* @__PURE__ */ r(
              ie,
              {
                noAlert: !0,
                required: E,
                label: a,
                placeholder: g,
                input: {
                  name: t,
                  value: C,
                  onChange: (N) => c(N?.target.value ?? ""),
                  onBlur: p.onBlur
                },
                ...!s && {
                  prefix: {
                    type: "button",
                    button: { icon: "close", onClick: l }
                  }
                }
              }
            ),
            /* @__PURE__ */ r(
              ie,
              {
                noAlert: !0,
                required: E,
                label: u,
                placeholder: f,
                input: {
                  name: t,
                  value: w,
                  onChange: (N) => A(N?.target.value ?? ""),
                  onBlur: p.onBlur
                },
                ...!s && {
                  prefix: {
                    type: "button",
                    button: { icon: "close", onClick: l }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
}, _t = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, _n = ({
  integrationType: e,
  integrationId: t,
  widgetName: n,
  isCreationMode: o,
  isSubmitting: i,
  automationCouplingState: s,
  onConfirmDelete: a,
  labels: u,
  deleteConfirmationBody: g,
  confirmDeleteVariant: f = "primary"
}) => {
  const { track: l } = ee(), [p, d] = m(!1), C = { ..._t, ...u }, y = !s || !s.isCoupled, w = () => {
    t && l("settings:view:delete:requested", {
      widgetId: t,
      widgetType: e
    }), d(!0);
  }, b = () => {
    t && l("settings:view:delete:canceled", {
      widgetId: t,
      widgetType: e
    });
  };
  return /* @__PURE__ */ h(_, { children: [
    /* @__PURE__ */ h(M, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ r(P, { type: "submit", isLoading: i, disabled: i, children: C.submit }),
      !o && /* @__PURE__ */ r(
        de,
        {
          content: "The widget is used in automations",
          disabled: y,
          children: /* @__PURE__ */ r(
            P,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: w,
              disabled: !y,
              isLoading: s?.isLoading,
              children: C.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ r(
      mt,
      {
        isOpen: p,
        setIsOpen: d,
        confirmVariant: f,
        confirmLabel: C.confirmDelete,
        cancelLabel: C.cancelDelete,
        onCancel: b,
        onConfirm: a,
        children: /* @__PURE__ */ r(M, { children: g ?? /* @__PURE__ */ h(_, { children: [
          "Are you sure you want to delete the ",
          e,
          ' integration "',
          n,
          '"?'
        ] }) })
      }
    )
  ] });
}, Rt = k`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Lt = k`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Rn(e) {
  const { useQuery: t, useMutation: n } = Ae(), [o, i] = m(), [s, a] = m(), [u, g] = m(!1), {
    loading: f,
    data: l,
    error: p
  } = t(
    Rt,
    {
      skip: !e,
      variables: {
        conversationId: e?.toString()
      }
    }
  ), [d, { loading: C, error: y }] = n(
    Lt
  ), w = async (b, c) => await d({
    variables: {
      conversationId: (c ?? e)?.toString(),
      data: b
    }
  }).then(
    ({ data: E }) => i(E?.Storage?.storeWidgetData?.data ?? {})
  );
  return T(() => {
    !f && l && i(l?.Storage?.widgetData ?? {});
  }, [l, f]), T(() => p && a(p), [p]), T(() => g(f), [f]), T(() => y && a(y), [y]), T(() => g(C), [C]), {
    data: o,
    loading: u,
    store: w,
    error: s
  };
}
const Ln = ({
  integrationId: e,
  integrationType: t,
  handleRedirect: n,
  showNotification: o
}) => {
  const { track: i } = ee(), [s, a] = m(!1), [u, g] = m(), [f, l] = m(null), p = K(
    (A) => (E) => {
      g(E), a(!1), o({
        title: "Something went wrong",
        text: `The ${A} of the widget was not successful.`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    [o]
  ), [d] = B(fe, {
    onError: p("creation")
  }), [C] = B(he, {
    onError: p("update")
  }), [y] = B(Ce, {
    onError: p("deletion")
  }), w = K(
    async ({
      name: A,
      enabled: E,
      settings: N,
      renderConditions: W = []
    }) => {
      i("settings:create:submitted", { widgetType: t }), a(!0), g(void 0);
      const { data: F } = await d({
        variables: {
          type: t,
          name: A,
          enabled: E,
          settings: N,
          renderConditions: W
        }
      });
      a(!1);
      const O = F?.Management?.createWidgetConfiguration;
      if (!O) {
        o({
          title: "Something went wrong",
          text: "The creation of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      o({
        title: "Creating was successful",
        text: "Creating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), n(O.id);
    },
    [d, n, t, o, i]
  ), b = K(
    async ({
      name: A,
      enabled: E,
      settings: N,
      renderConditions: W
    }) => {
      if (!e)
        return;
      i("settings:view:change:submitted", {
        widgetId: e,
        widgetType: t
      }), a(!0), g(void 0);
      const { data: F } = await C({
        variables: {
          id: e,
          name: A,
          enabled: E,
          settings: N,
          ...W !== void 0 && { renderConditions: W }
        }
      });
      a(!1);
      const O = F?.Management?.updateWidgetConfiguration;
      if (!O) {
        o({
          title: "Something went wrong",
          text: "The update of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      O.misconfigured ? l(
        O.misconfigurationCause ?? X
      ) : l(null), o({
        title: "Updating was successful",
        text: "Updating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    },
    [e, t, o, i, C]
  ), c = K(async () => {
    if (!e)
      return;
    i("settings:view:delete:confirmed", {
      widgetId: e,
      widgetType: t
    }), a(!0), g(void 0);
    const { data: A } = await y({
      variables: { id: e }
    });
    a(!1), A?.Management?.deleteWidgetConfiguration && (n(), o({
      title: "Deletion was successful",
      text: "The deletion of the widget was successful.",
      icon: "check-circle-filled",
      severity: "success"
    }));
  }, [
    y,
    n,
    e,
    t,
    o,
    i
  ]);
  return {
    create: w,
    update: b,
    remove: c,
    isLoading: s,
    error: u,
    misconfigurationCause: f,
    setMisconfigurationCause: l
  };
};
function Bn({
  integrationId: e,
  fieldDefinitions: t,
  form: n,
  onMisconfigured: o
}) {
  const [i, s] = m(!1), [a, u] = m(), { loading: g, error: f, refetch: l } = ce(pe, {
    variables: { id: e },
    skip: !e,
    onCompleted: (p) => {
      const d = p?.Management?.widgetConfigurations?.[0];
      if (!d) {
        s(!0), u(void 0);
        return;
      }
      s(!1), u(d), n.reset({
        ...At(d.settings ?? [], t),
        enabled: !!d.enabled,
        name: d.name
      }), d.misconfigured && o?.(
        d.misconfigurationCause ?? X
      );
    }
  });
  return T(() => {
    s(!1), u(void 0);
  }, [e]), {
    isLoading: g,
    error: f,
    isWidgetUnknown: i,
    refetch: l,
    widgetConfiguration: a
  };
}
function $n({
  integrationId: e,
  widgetConfiguration: t,
  renderConditionsEditor: n
}) {
  const o = !e, [i, s] = m(o ? [] : null);
  return T(() => {
    s(o ? [] : null);
  }, [e, o]), T(() => {
    t && i === null && s(t.renderConditions ?? []);
  }, [t, i]), {
    renderConditions: i,
    setRenderConditions: s,
    renderConditionsForSubmit: !!n && i !== null && i !== null ? i : void 0
  };
}
export {
  ye as DisplayErrors,
  rn as DixaApiTokenSettings,
  be as InboundOAuthContext,
  mt as IntegrationModal,
  xn as KlaviyoSubscribeSetting,
  hn as MisconfigurationBanner,
  In as OAuthSettings,
  Wn as PartnerHookFormBasicAuth,
  kn as PartnerHookFormSecretText,
  fn as PartnerSettingsWrapper,
  wt as WidgetContextProvider,
  _n as WidgetSettingsFormFooter,
  yn as capitalizeFirstCharacter,
  En as countryCodes,
  yt as createMockInboundOAuthContextOptions,
  Tn as createWidgetConfigurationCreateMock,
  vn as createWidgetConfigurationDeleteMock,
  fe as createWidgetConfigurationMutation,
  Mn as createWidgetConfigurationQueryMock,
  Dn as createWidgetConfigurationUpdateMock,
  Cn as deepClone,
  we as defaultDateFormat,
  X as defaultMisconfigurationCause,
  Et as defaultPartnerSettingsConfiguration,
  bt as defaultWidgetContextValue,
  Ce as deleteWidgetConfigurationMutation,
  Pn as displayAttributeValue,
  Nt as formValuesToSettings,
  Tt as getConnectionStatusValues,
  bn as getCountryNameFromCountryCode,
  Ot as getListsQuery,
  St as getPartnerDevApiHeaders,
  pe as getWidgetConfigurationByIdQuery,
  On as handleWidgetSubmit,
  sn as hasDixaHeaderCheckError,
  an as hasDownstreamApiAuthorizationError,
  gn as hasDownstreamApiBadRequestError,
  un as hasDownstreamApiConflictError,
  mn as hasDownstreamApiForbiddenError,
  dn as hasDownstreamApiNotFoundError,
  cn as hasDownstreamApiPermissionError,
  ln as hasDownstreamApiServiceUnavailableError,
  pn as hasDownstreamApiTooManyRequestsError,
  lt as hasWidgetMisconfiguredError,
  wn as humanizeKey,
  Xe as isDixaHeaderCheckError,
  et as isDownstreamApiAuthorizationError,
  it as isDownstreamApiBadRequestError,
  rt as isDownstreamApiConflictError,
  st as isDownstreamApiForbiddenError,
  ot as isDownstreamApiNotFoundError,
  tt as isDownstreamApiPermissionError,
  nt as isDownstreamApiServiceUnavailableError,
  at as isDownstreamApiTooManyRequestsError,
  Mt as isRunningLocalPartnerApi,
  ct as isWidgetMisconfiguredError,
  nn as makeExecuteQuery,
  tn as makeUseLazyQuery,
  on as makeUseMutation,
  en as makeUseQuery,
  ft as parseAccessToken,
  pt as parseBoolean,
  ht as parseString,
  Sn as renderPartnerSettings,
  At as settingsToFormValues,
  Nn as stubPartnerEventsBusForTests,
  he as updateWidgetConfigurationMutation,
  dt as useCopyWithDelay,
  Rn as useData,
  Ct as useInboundOAuthContext,
  $n as useRenderConditions,
  ee as useTracking,
  Ae as useWidgetContext,
  Ln as useWidgetSettingsMutations,
  Bn as useWidgetSettingsQuery,
  An as validateApiHostName
};
